import { render, staticRenderFns } from "./CeoMediaNews.vue?vue&type=template&id=e0bf074e&scoped=true&"
import script from "./CeoMediaNews.vue?vue&type=script&lang=js&"
export * from "./CeoMediaNews.vue?vue&type=script&lang=js&"
import style0 from "./CeoMediaNews.vue?vue&type=style&index=0&id=e0bf074e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0bf074e",
  null
  
)

export default component.exports